import { useProductionPlanSettings } from '../../../components';
import { NodeLabel } from './NodeLabel';

type ProductionOrderNumberProps = {
  productionOrderNumber?: string;
  productionOrderExternalNumber?: string;
};
export const ProductionOrderNumber = ({
  productionOrderNumber,
  productionOrderExternalNumber,
}: ProductionOrderNumberProps) => {
  const showOnTask = useProductionPlanSettings((state) => state.gantt.showOnTask);
  const showProductionOrderNumber = showOnTask.productionOrderNumber && productionOrderNumber;
  const showProductionOrderExternalNumber = showOnTask.productionOrderExternalNumber && productionOrderExternalNumber;

  return (
    <>
      {showProductionOrderNumber && productionOrderNumber && (
        <NodeLabel className="min-w-0 shrink-4">{productionOrderNumber}</NodeLabel>
      )}
      {showProductionOrderExternalNumber && productionOrderExternalNumber && (
        <NodeLabel className="min-w-0 shrink-5">{productionOrderExternalNumber}</NodeLabel>
      )}
    </>
  );
};
